import { render } from "./SmallProject.vue?vue&type=template&id=61320d7f"
import script from "./SmallProject.vue?vue&type=script&lang=js"
export * from "./SmallProject.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__